import React, { useMemo } from "react";

const formatDayLabel = (dateStr) => {
    const today = new Date().toDateString();
    const yesterday = new Date(Date.now() - 86400000).toDateString();
    if (dateStr === today) return "Today";
    if (dateStr === yesterday) return "Yesterday";
    return new Date(dateStr).toLocaleDateString(undefined, {
        weekday: "long",
        year: "numeric",
        month: "short",
        day: "numeric",
    });
};

function Messages({ messages, username }) {
    const grouped = useMemo(() => {
        const g = {};
        messages.forEach((msg) => {
            const date = new Date(msg.timestamp).toDateString();
            if (!g[date]) g[date] = [];
            g[date].push(msg);
        });
        return g;
    }, [messages]);

    return (
        <div className="flex-1 min-h-0 overflow-y-auto p-2 sm:p-4 bg-black space-y-2 sm:space-y-3">
            {Object.entries(grouped).map(([date, msgs]) => (
                <div key={date}>
                    <div className="text-center text-gray-400 text-[10px] sm:text-sm my-2 sm:my-4">
                        {formatDayLabel(date)}
                    </div>
                    {msgs.map((msg, idx) => (
                        <div
                            key={idx}
                            className={`max-w-[85%] sm:max-w-[75%] w-fit p-2 sm:p-3 rounded-xl break-words mt-2 sm:mt-3 ${(msg.from || msg.username) === username
                                ? "ml-auto bg-white text-black"
                                : "bg-gray-700 text-gray-300"
                                }`}
                        >
                            <div className="text-[11px] sm:text-sm font-semibold mb-1">
                                {(msg.from || msg.username) === username ? "You" : msg.from || msg.username}
                            </div>
                            <div className="text-sm sm:text-base">{msg.content}</div>
                            <div
                                className="text-[10px] sm:text-xs text-gray-400 mt-1 text-right"
                                title={new Date(msg.timestamp).toLocaleString()}
                            >
                                {new Date(msg.timestamp).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
                                {msg.seen && msg.from === username && (
                                    <span className="ml-2 text-blue-400">✓ Seen</span>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
}

export default Messages;


